import { ApeironSsoQuery as o } from "../constants/apeironSso.js";
import y from "../constants/config.js";
import { HostName as h, LocalSsoUrl as N } from "../constants/login.js";
import { queryGet as a } from "../../common-lib/utils/query.js";
import { nanoid as C } from "nanoid";
import { useRouter as R } from "next/router";
import c from "query-string";
import * as r from "ramda";
import { useRef as w, useMemo as A, useCallback as f } from "react";
const k = () => {
  const { query: s } = R(), u = w(!1), d = A(() => typeof window < "u" ? window.location.hostname === h.Localhost : !1, []), m = f(
    (t) => {
      const e = a(
        s,
        o.SsoRedirectUrl
      );
      if (r.isNil(e) || u.current)
        return;
      const i = a(
        s,
        o.SsoHandleUrl
      ), n = r.isNotNil(t) ? {
        [o.OAuthCode]: t.code,
        [o.OAuthState]: t.state
      } : {}, l = r.isNotNil(i) ? c.stringifyUrl({
        url: i,
        query: {
          ...n,
          [o.SsoRedirectUrl]: e || "/"
        }
      }) : c.stringifyUrl({
        url: e || "",
        query: {
          ...n
        }
      });
      u.current = !0, window.location.assign(l);
    },
    [s]
  ), p = f(
    (t) => {
      const { redirectUrl: e } = t, i = r.propOr(null, "clientId", t), n = r.propOr(
        null,
        "ssoHandleUrl",
        t
      ), l = r.isNotNil(i) ? {
        [o.OAuthClientId]: i,
        [o.OAuthResponseType]: "code",
        [o.OAuthScope]: "openid",
        [o.OAuthState]: C()
      } : {}, U = r.isNotNil(n) ? { [o.SsoHandleUrl]: n } : {}, S = {
        [o.SsoRedirectUrl]: e,
        ...l,
        ...U
      }, g = c.stringifyUrl({
        url: d ? N : y.sso.domain.site,
        query: S
      });
      window.location.assign(g);
    },
    [d]
  );
  return {
    jumpToClient: m,
    jumpToSso: p
  };
};
export {
  k as default
};
//# sourceMappingURL=useApeironSsoRedirect.js.map
